import styled from '@emotion/styled'
import { SiteMetricsByTime } from '@pubstack/common/src/analytics/query'
import { CurrencySymbol } from '@pubstack/common/src/currency'
import { Timezone } from '@pubstack/common/src/timezone'
import { DateTime } from 'luxon'
import { FunctionComponent } from 'react'
import { WidgetProps } from '~/components/Widget'
import { AnalyticsChartWidget } from '~/modules/analytics/AnalyticsChartWidget'
import { TimelineConfiguration, useTimelineChart } from '~/modules/analytics/analyticsTimeline.hooks'
import { auctionCount, hbBidDensity } from '~/modules/analytics/common/formulas'
import { WithClassName } from '~/types/utils'
import { PureSiteChartTitle } from './PureSiteChartTitle'

const config: TimelineConfiguration<SiteMetricsByTime> = {
  getChartOptions: () => ({ seriesType: 'line' }),
  legendConfig: ['hb'],
  tooltipConfig: ['hb'],
  dataConfig: [
    {
      name: 'hb',
      label: hbBidDensity.name,
      iconName: 'data_line',
      getFormula: () => hbBidDensity,
      isComputable: ({ data }) => auctionCount.isComputable(data) && hbBidDensity.isComputable(data),
      withValue: true,
    },
  ],
}

type PureSiteBidDensityChartProps = WithClassName &
  Omit<WidgetProps, 'title' | 'info' | 'icon' | 'refreshTrackingLabel'> & {
    data: SiteMetricsByTime
    currencySymbol: CurrencySymbol
    timezone: Timezone
    currentEpoch: DateTime
  }
const UnstyledPureSiteBidDensityChart: FunctionComponent<PureSiteBidDensityChartProps> = ({ data, timezone, currencySymbol, currentEpoch, ...props }) => {
  const averageDensity = auctionCount.isComputable(data) && hbBidDensity.isComputable(data) ? hbBidDensity.displayable(hbBidDensity.sum(data)) : ''
  const title = <PureSiteChartTitle title={hbBidDensity.name} infoLabel={'average'} infoValue={averageDensity.toString()} />

  const { chart, legends } = useTimelineChart({ currentConfig: config, data, currencySymbol, currentEpoch, timezone })
  return <AnalyticsChartWidget {...props} icon={'site'} title={title} chart={chart} legends={legends} refreshTrackingLabel={'ana-sites-detail-bid-density-refresh'} />
}
export const PureSiteBidDensityChart = styled(UnstyledPureSiteBidDensityChart)``
